<template>
  <el-dialog :title="title" :visible.sync="showDialog" append-to-body width="500px">
    <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-width="80px">
      <el-form-item label="密码" prop="password">
        <el-input v-model="ruleForm.password" type="password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="password" v-if="!issuePassword">
        <el-input v-model="ruleForm.againPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{issuePassword ? '验证密码' : '创建密码'}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      title: '验证密码',
      showDialog: false,
      ruleForm: {
        password: '',
        againPassword: ''
      },
      rules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        againPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      issuePassword: "makeCard/issuePassword", // 是否设置了盖章密码
    }),
    // issuePassword: () => false
  },
  mounted() {
    this.title = this.issuePassword ? '验证密码' : '请先创建验证密码';
  },
  watch: {
    issuePassword: {
      immediate: true,
      handler(newValue) {
        this.title = newValue ? '验证密码' : '请先创建验证密码';
      }
    }
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    submitForm(formName) {
      if (!this.issuePassword && this.ruleForm.againPassword !== this.ruleForm.password) {
        this.$message({
          message: '两次输入的密码不一致',
          type: 'warning'
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.issuePassword) {
            // 验证密码
            this.checkPassword();
          } else {
            // 创建密码
            this.createPassword();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 创建密码
    createPassword() {
      this.$api.createIssuePassword({
        issuePassword: this.ruleForm.password
      }).then(res => {
        this.$successCallback(
          res,
          '密码创建成功',
          () => {
            this.$store.commit('makeCard/updateIssuePassword', true);
            this.ruleForm.password = '';
            this.ruleForm.againPassword = '';
            this.close();
          }
        )
      })
    },
    // 验证密码
    checkPassword() {
      this.$api.checkIssuePassword({
        issuePassword: this.ruleForm.password
      }).then(res => {
        this.$successCallback(
          res,
          '验证成功',
          () => {
            this.close();
            this.$emit('checkSuccess');
          }
        )
      })
    }
  }
}
</script>
<style lang='less' scoped>

</style>